import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const SignUpButton = props => {
  const {
    handleOpenSignUpModal
  } = props;

  return (
    <Fragment>
      <button
        className="header-button__link header-button__link--sign-up"
        type="button"
        onClick={handleOpenSignUpModal}
      >
        <span className="header-button--account-label">Sign Up</span>
      </button>
    </Fragment>
  );
};

SignUpButton.propTypes = {
  handleOpenSignUpModal: PropTypes.func.isRequired
};

export default SignUpButton;


// WEBPACK FOOTER //
// ./src/components/Header/SignUpButton.js